import { createClient, type Session } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export async function syncSessionCookie(session: Session | null): Promise<void> {
  if (session) {
    await fetch('/api/auth/supabase-session', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        access_token: session.access_token,
        expires_in: session.expires_in,
      }),
    });
  } else {
    await fetch('/api/auth/supabase-session', { method: 'DELETE' });
  }
}
